// Notes are stored as HTML from the rich-text editor; spreadsheets need plain text.

const BLOCK_TAGS = new Set([
    'p', 'div', 'ul', 'ol', 'li', 'table', 'thead', 'tbody', 'tfoot', 'tr', 'blockquote', 'pre',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'section', 'article', 'header', 'footer',
])

const NAMED_ENTITIES: Record<string, string> = { nbsp: ' ', amp: '&', lt: '<', gt: '>', quot: '"', apos: "'" }

const decodeEntities = (text: string) =>
    text.replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, (entity, name: string) => {
        if (name[0] !== '#') return NAMED_ENTITIES[name.toLowerCase()] ?? entity
        const code = name[1] === 'x' || name[1] === 'X' ? parseInt(name.slice(2), 16) : parseInt(name.slice(1), 10)
        return code <= 0x10ffff ? String.fromCodePoint(code) : entity
    })

// Lays the text out the way a browser renders it: blocks and <br> start new lines,
// a <br> that only closes a block adds nothing, and whitespace collapses.
export const htmlToPlainText = (html: string): string => {
    const lines: string[] = []
    let line = ''
    const endLine = () => {
        lines.push(line.trimEnd())
        line = ''
    }
    const endBlock = () => {
        if (line.trim()) endLine()
    }

    const source = html.replace(/<(style|script)\b[\s\S]*?<\/\1\s*>/gi, '').replace(/<!--[\s\S]*?-->/g, '')

    for (const [token, closing, rawName] of source.matchAll(/<(\/?)([a-zA-Z][\w:-]*)[^>]*>|[^<]+|</g)) {
        if (rawName === undefined) {
            const text = decodeEntities(token).replace(/\s+/g, ' ')
            line += line === '' || line.endsWith(' ') ? text.trimStart() : text
            continue
        }
        const name = rawName.toLowerCase()
        if (name === 'br') {
            endLine()
        } else if (BLOCK_TAGS.has(name)) {
            endBlock()
            if (name === 'li' && !closing) line = '- '
        } else if ((name === 'td' || name === 'th') && !closing && line.trim()) {
            line = line.trimEnd() + ' | '
        }
    }
    endBlock()

    return lines.join('\n').replace(/\n{3,}/g, '\n\n').trim()
}
